import { defineStore } from 'pinia';
import { ref } from 'vue';

import { userInfo, userLogin, userLogout, userPhoneLogin } from '@/api/login';
import { usePermissionStore } from '@/store';

// import type { UserInfo } from '@/types/interface';

const InitUserInfo = ref({
  name: '', // 用户名，用于展示在页面右上角头像处
  roles: ['all'], // 前端权限模型使用 如果使用请配置modules/permission-fe.ts使用
});

export const useUserStore = defineStore('user', {
  state: () => ({
    token: '', // 默认token不走权限
    userInfo: { ...InitUserInfo.value },
  }),
  getters: {
    roles: (state) => {
      return state.userInfo?.roles;
    },
  },
  actions: {
    async login(loginForm: Record<string, unknown>, type: string) {
      let params = {};
      if (type === 'phone') {
        params = { phone: loginForm.phone, verificationCode: loginForm.verificationCode };
        const { data } = await userPhoneLogin(params);
        // 登录成功后处理
        this.token = data.token;
      } else {
        params = { userName: loginForm.userName, password: loginForm.password };
        const { data } = await userLogin(params);
        // 登录成功后处理
        this.token = data.token;
      }
    },

    async getUserInfo() {
      const { data } = await userInfo();
      this.userInfo = {
        name: data.nickname,
        roles: ['all'],
        ...data,
      };
      // this.userInfo = {
      //   name: data.nickname,
      //   roles: ['all'], // 前端权限模型使用 如果使用请配置modules/permission-fe.ts使用
      //   ...data,
      // };
      // this.userInfo = {
      //   name: '',
      //   roles: ['all'], // 前端权限模型使用 如果使用请配置modules/permission-fe.ts使用
      // };
    },

    async logout() {
      try {
        // await userLogout();
      } catch (e) {
        console.log(e);
      } finally {
        this.token = '';
        this.userInfo = { ...InitUserInfo.value };
        usePermissionStore().restore();
      }
    },
  },
  persist: {
    afterRestore: () => {
      const permissionStore = usePermissionStore();
      permissionStore.initRoutes(InitUserInfo.value.roles);
    },
    key: 'jjyCloud',
    paths: ['token', 'userInfo', 'accountList'],
  },
});
